// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Erwx","footer":"ChangeClinic_footer__1Hawo"};